import { useFormatter } from 'next-intl';

import { useDiscountPreview } from '@/queries/GetDiscountPreview';

interface FormattedDiscountPreview {
  formattedAmount: string;
  isLoading: boolean;
}

export default function useFormattedDiscountPreview(
  discountCode: string | undefined,
): FormattedDiscountPreview {
  const format = useFormatter();
  const { isLoading, data: previewData } = useDiscountPreview(discountCode);

  if (isLoading) {
    return { isLoading, formattedAmount: '' };
  }

  const primaryPriceRule = previewData?.priceRules?.[0];

  if (!primaryPriceRule) {
    return { isLoading, formattedAmount: '' };
  }

  if (primaryPriceRule.amount) {
    const price = primaryPriceRule.amount.amount ?? 0;
    const fractionDigits = price % 1 === 0 ? 0 : 2;
    const formattedAmount = format.number(price, {
      style: 'currency',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      currency: primaryPriceRule.amount.currencyCode!,
    });

    return { isLoading, formattedAmount };
  }

  return { isLoading, formattedAmount: '' };
}
